import { Link } from "react-router-dom";
import CartItems from "./CartItems";
import { useCart } from "../../context/CartContext";
import { Offcanvas } from "react-bootstrap";
import { ShoppingBag, Truck, ShieldCheck, ArrowRight } from "lucide-react";

function CartCanvas() {
  const { cartItems, cartSummary } = useCart();

  return (
    <>
      <Offcanvas.Header className="custom-cart-header">
        <div className="custom-cart-heading">
          <div className="custom-cart-bag-icon">
            <ShoppingBag size={22} />
          </div>

          <div>
            <Offcanvas.Title className="custom-cart-title">
              YOUR BAG
              {cartItems?.length > 0 && (
                <span className="custom-cart-count">
                  {cartItems.length}
                </span>
              )}
            </Offcanvas.Title>

            <span className="custom-cart-caption">
              Your selected rides
            </span>
          </div>
        </div>

        <button
          type="button"
          className="custom-cart-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        >
          ×
        </button>
      </Offcanvas.Header>

      <div className="custom-cart-divider" />

      <Offcanvas.Body className="custom-cart-body">
        {cartItems && cartItems.length ? (
          <>
            

            {/* CART ITEMS */}
            <div className="custom-cart-items-list">
              {cartItems.map((item, index) => (
                <CartItems
                  key={item._id || index}
                  item={item}
                />
              ))}
            </div>

            {/* FOOTER */}
            <div className="custom-cart-footer">

              <div className="custom-cart-secure">
                <ShieldCheck size={17} />
                <span>100% Secure Checkout</span>
              </div>

              <div className="custom-cart-summary">
                <div className="custom-cart-total-row">
                  <span>Subtotal</span>
                  <strong>₹{cartSummary.total}</strong>
                </div>

                <div className="custom-cart-total-row">
                  <span>Shipping</span>
                  <strong className="custom-free-text">
                    ₹{cartSummary.shipping}
                  </strong>
                </div>

                <div className="custom-cart-total-divider" />

                <div className="custom-cart-grand-total">
                  <span>TOTAL</span>
                  <strong>₹{cartSummary.total}</strong>
                </div>
              </div>

              <Link
                to="/cart"
                className="custom-cart-btn-view"
              >
                <span>GO TO CART</span>
                <ArrowRight size={21} />
              </Link>

              <Link
                to="/shop"
                className="custom-cart-continue"
              >
                CONTINUE SHOPPING
              </Link>

            </div>
          </>
        ) : (
          <div className="custom-empty-cart">

            <div className="custom-empty-cart-icon">
              <ShoppingBag size={42} />
            </div>

            <h3>Your Bag is Empty</h3>

            <p>
              Looks like you haven't added any ride yet.
            </p>

            <Link
              to="/shop"
              className="custom-empty-cart-btn"
            >
              START SHOPPING
              <ArrowRight size={18} />
            </Link>

          </div>
        )}
      </Offcanvas.Body>
    </>
  );
}

export default CartCanvas;